import { OpenInNew } from "@mui/icons-material";
import {
  Dialog,
  TextField,
  Card,
  IconButton,
  Box,
  CardActionArea,
  Skeleton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { Link, useFetcher, useSearchParams } from "react-router-dom";
import { WrappedCollection } from "services/api.service";
import { ProductCatalog } from "types/productCatalog";

export const CopyAttributesDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const [, setParams] = useSearchParams();
  const [fetcherKey, setFetcherKey] = useState<string>(() => `${Date.now()}`);
  const fetcher = useFetcher<WrappedCollection<ProductCatalog>>({ key: fetcherKey });

  function handleClose() {
    onClose();
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
      }}
      onTransitionExited={() => {
        // Reset the fetcher key to clear out old data when the dialog is closed
        setFetcherKey(`${Date.now()}`);
      }}
    >
      <Stack p={2} gap={2} sx={{ minWidth: 600 }}>
        <Typography variant="h5">Copy attributes from product</Typography>
        <fetcher.Form method="GET" action="/product-catalog/search">
          <TextField fullWidth label="MPN" name="q" placeholder="Search by MPN..." autoFocus required />
        </fetcher.Form>
        <Box sx={{ display: "grid", gridTemplateColumns: "120px 1fr 64px", gap: 1 }}>
          {fetcher.state === "loading" && <Skeleton variant="rounded" height={50} sx={{ gridColumn: "1 / -1" }} />}
          {fetcher.state !== "loading" && fetcher.data && (
            <>
              {fetcher.data.rows.length > 0 ? (
                fetcher?.data.rows.map((pc) => (
                  <Card
                    key={pc.id}
                    variant="outlined"
                    sx={{ display: "grid", gridTemplateColumns: "subgrid", gridColumn: "1 / -1" }}
                  >
                    <CardActionArea
                      onClick={() => {
                        setParams({ copyFrom: pc.id.toString() }, { replace: true });
                        handleClose();
                      }}
                      sx={{ display: "grid", gridTemplateColumns: "subgrid", gridColumn: "1 / -2" }}
                    >
                      <Box sx={{ whiteSpace: "nowrap", placeContent: "center", p: 1 }}>
                        <Typography>{pc.merchantProductNumber}</Typography>
                      </Box>
                      <Box sx={{ p: 1 }}>
                        <Typography>{pc.title || <i>Title not specified</i>}</Typography>
                      </Box>
                    </CardActionArea>
                    <Box sx={{ placeContent: "center", p: 1 }}>
                      <Link to={`/product-catalog/${pc.id}`} target="_blank">
                        <Tooltip title="Open in new window">
                          <IconButton>
                            <OpenInNew />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    </Box>
                  </Card>
                ))
              ) : (
                <Typography sx={{ gridColumn: "1 / -1", py: 2, textAlign: "center" }}>No results found</Typography>
              )}
            </>
          )}
        </Box>
      </Stack>
    </Dialog>
  );
};
